/**
 * Split assistant content + tool calls into ordered render blocks for
 * inline rendering. Lifted from `apps/agent/client/src/pages/chat.tsx`
 * (~853-873).
 */

import type { ChatToolCall } from '../types'

export type InterleavedBlock = { kind: 'text'; content: string } | { kind: 'tool'; call: ChatToolCall }

export function interleaveContentAndTools(content: string, toolCalls: ChatToolCall[]): InterleavedBlock[] {
  const sorted = [...toolCalls].sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
  const blocks: InterleavedBlock[] = []
  let cursor = 0
  for (const call of sorted) {
    const pos = Math.max(cursor, Math.min(call.position ?? cursor, content.length))
    const segment = content.slice(cursor, pos)
    if (segment.length > 0) {
      blocks.push({ kind: 'text', content: segment })
    }
    blocks.push({ kind: 'tool', call })
    cursor = pos
  }
  const tail = content.slice(cursor)
  if (tail.length > 0) {
    blocks.push({ kind: 'text', content: tail })
  }
  return blocks
}
